import React, { createContext, useRef, useState } from "react";

const SPQSUndoContext = createContext({});

export const SPQSUndoProvider = ({ children }) => {
  const SPQSEdits = useRef([]);
  const undoListSPQS = useRef([]);
  const [editIDSPQS, setEditIDSPQS] = useState(0);
  const [editingFieldSPQS, setEditingFieldSPQS] = useState(false);
  const [showcalculatorSPQS, setShowcalculatorSPQS] = useState();
  const inputRefsSPQS = useRef({});
  const [undoFocusFlagSPQS, setUndoFocusFlagSPQS] = useState();
  const [reloadpaytermsSPQS, setReloadpaytermsSPQS] = useState(false);

  return (
    <SPQSUndoContext.Provider
      value={{
        SPQSEdits,
        editIDSPQS,
        setEditIDSPQS,
        editingFieldSPQS,
        setEditingFieldSPQS,
        undoListSPQS,
        showcalculatorSPQS,
        setShowcalculatorSPQS,
        inputRefsSPQS,
        undoFocusFlagSPQS,
        setUndoFocusFlagSPQS,
        reloadpaytermsSPQS,
        setReloadpaytermsSPQS,
      }}
    >
      {children}
    </SPQSUndoContext.Provider>
  );
};

export default SPQSUndoContext;
